import React, { Component } from "react";

import { assetImg } from "@/modules/moduleImporter";
import { getATValue } from "@/modules/commonPopupResultHistory";

import { IGameResultHistoryProps, IGongBallHistoryType } from "@/types/GameHistoryTypes";

import "./index.scss";
import { isNullOrEmpty } from "@/modules/commonMobile";

interface IProps extends Omit<IGameResultHistoryProps, "history"> {
	history: IGongBallHistoryType[];
}

export default class M16 extends Component<IProps> {
	History(props) {
		const angka: string[] = !isNullOrEmpty(props.result) ? (
			props.result === "Banker" ?
			props.angka1.split(",") : props.angka2.split(",")
		) : [];

		const total = angka.map(num => getATValue(num))
			.reduce((a, b) => a + b) % 10;
		
		return (
			<div className={props.blink ? "sl-roadmap-alternating" : ""}>
				{ 
					angka.map((item, idx) =>
						assetImg("gb_history", item + "", "angka_" + idx)
					)
				}
				
				<div>
				{ assetImg("gb_cards", total + "") }
				</div>

				<div className={props.result === "Player" ? "sl-blue" : "sl-red-darken"}>
					{props.result[0]}
				</div>
			</div>
		);
	}

	render() {
		const reversedHistory = this.props.history.slice(0).reverse();
		const History = this.History;
		const historyBlink = this.props.historyBlink;
		
		return (
			<div className="history-container m16">
				{
					this.props.activeGameCount === 1 ?
					reversedHistory.slice(0, 7).map((data, idx) =>
						data.result &&
						<History
							key={`m16_hist_${idx}`}
							// angka={data.angka}
							angka1={data.angka1}
							angka2={data.angka2}
							result={data.result}
							blink={historyBlink && idx === 0}
							/>
					) :
					reversedHistory.slice(0, 5).map((data, idx) =>
						data.result &&
						<History
							key={`m16_hist_${idx}`}
							// angka={data.angka}
							angka1={data.angka1}
							angka2={data.angka2}
							result={data.result}
							blink={historyBlink && idx === 0}
							/>
					)
				}
			</div>
		);
	}
}
